import { FilterFn, Row } from "@tanstack/react-table";

export const matchesSearch = (
  texts: (string | undefined)[],
  search: string,
): boolean => {
  const searchText = search.trim().toLowerCase();
  return texts.some((text) => text?.toLowerCase().includes(searchText));
};

export const searchFilter =
  <T>(searchableTexts: (row: Row<T>) => (string | undefined)[]): FilterFn<T> =>
  (row, _columnId, search: string) =>
    matchesSearch(searchableTexts(row), search);
